<form snDrawer [formGroup]="form" (ngSubmit)="submitForm()">
  <sn-drawer-header [title]="'appliances.dialogs.editFususCore' | t">
    <sn-icon-button icon="close" snDrawerClose snDrawerNavButton></sn-icon-button>
    <sn-drawer-header-actions>
      <button
        mat-button
        type="submit"
        color="success"
        [disabled]="form.invalid"
        [mtBasicSpinner]="isLoading"
        [hideText]="true"
      >
        {{ 'common.save' | t }}
      </button>
    </sn-drawer-header-actions>
  </sn-drawer-header>

  <sn-drawer-content indented>
    <sn-form [form]="form" [fields]="formFields" [(model)]="formModel"></sn-form>
  </sn-drawer-content>
</form>
